module.exports = __webpack_public_path__ + "img/drop-down.c8114031.svg";